import React from 'react';
import { connect } from 'react-redux';

import Global from '../../../store/global-selectors';
import { ApplyPreset } from '../../../components/orders-drawer/sections/apply-preset';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { mapDispatchToOnClick, mapStateToOpen } from './section-container-helper';
import { ShipmentConfigurationService } from '../../../services/shipping-configuration-service';
import { BULK_UPDATE_DRAWER_BULK_UPDATE_JOB_ID } from '../../../store/orders/drawer/constants';
import { useModal } from '../../../hooks/use-modal';
import { ManagePresetsModal } from '../../../components/modals/manage-presets-modal';

const sectionId = 'apply-preset';

const mapStatesToProps = (state) => {
  const bulkUpdateJobId = BULK_UPDATE_DRAWER_BULK_UPDATE_JOB_ID;
  const bulkJob = Global.selectBulkUpdateBulkUpdateJob(state, {
    bulkUpdateJobId,
  });
  const isFedexHal = ShipmentConfigurationService.orderSelectionContainsHalService(state) || false;

  const openState = mapStateToOpen(state, sectionId);

  if (!bulkJob.id) {
    return {
      ...openState,
      isLoading: true,
      bulkUpdateJobId,
    };
  }
  const { isLoading, model, jobData } = bulkJob;
  return {
    ...openState,
    isLoading,
    model,
    jobData,
    bulkUpdateJobId,
    isFedexHal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ...mapDispatchToOnClick(dispatch, sectionId),
    onModelChange: (bulkUpdateJobId, newModel) => dispatch(BulkUpdateActions.setModel(bulkUpdateJobId, newModel)),
    applyPreset: (bulkUpdateJobId) => dispatch(BulkUpdateActions.validateBulkUpdateJob(bulkUpdateJobId)),
  };
};

const ApplyPresetContainer = (props) => {
  const { close: closeManagePresetsModal, isOpen: isManagePresetsModalOpen, open: openManagePresetsModal } = useModal();

  return (
    <React.Fragment>
      <ApplyPreset {...props} managePresets={openManagePresetsModal} />
      {isManagePresetsModalOpen && <ManagePresetsModal onClose={closeManagePresetsModal} />}
    </React.Fragment>
  );
};

export const ApplyPresetConnected = connect(mapStatesToProps, mapDispatchToProps)(ApplyPresetContainer);
